import React, { useState, useEffect, useCallback, useRef } from 'react'
import { ReactComponent as QrButton } from '../../../Assets/img/icons/qr-button-figma.svg'
import { ReactComponent as Wave } from '../../../Assets/img/card/wave-only-big.svg'
import sampleAd from '../../../Assets/img/sample-ad.jpg'
import { Avatar, Box } from '@mui/material'
import { useProfileContext } from '../../ProfileDetailContext'
import { useUserDetailContext } from '../../UserDetailContext'
import { useCardDetailContext } from '../../CardDetailContext';
import { MdOutlinePhoneIphone } from "react-icons/md";
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { ReactComponent as WhatsappFilled } from '../../../Assets/img/icons/whatsapp-filled.svg';
import DefaultUniversity from "../../../Assets/img/default-university-logo.jpg"
import DefaultProfilePic from '../../../Assets/img/Default-Profile.jpg';

import VisitingCard from './SideFeedComponents/VisitingCard'
import JobOpenings from './SideFeedComponents/JobOpenings'
import UpcomingEvents from './SideFeedComponents/UpcomingEvents'
import SocialNetwork from './SideFeedComponents/SocialNetwork'
import Offers from './SideFeedComponents/OffersForUsers'
import RecommendedCourses from './SideFeedComponents/RecommCourses'
import QrCodeDialog from '../Cards/QrCodeDialog'
import axios from 'axios'
import useApi from '../../Utilities/useAPI'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { getVisitingCardReducer } from '../../../Redux/Reducers/CardReducer'
import RecommendedJobs from './SideFeedComponents/RecommendedJobs'
import SideBarAllEventCard from '../Community/Events/SideBarAllEventCard'
import { getAllEvents, getRegisteredAttendees, setExploreType } from '../../../Redux/Reducers/communityReducer'
import CommunityRightSideBar from '../Community/CommunityDashboard/CommunityRightSideBar'
import UpcomingEventsSidebar from './UpcomingEventsSidebar'

const SideFeedParent = ({ activeProfile, viewedUserId, encryptedId }) => {
  const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile);
  const Personaldata = useSelector((state) => state?.ProfileArray?.personalProfile?.data)
  const [event, setEvent] = useState("PERSONAL")
  // console.log("ProfessionalDataNN", Personaldata)
  const { userDetails } = useUserDetailContext();
  // console.log("userDetailsuserDetails", userDetails);
  // console.log("viewedUserIdviewedUserId", viewedUserId);
  const { callApiFunction } = useApi();

  const phoneNumber = userDetails?.phone?.replace(/\s+/g, "");
  const emailId = userDetails?.email;


  let profilePic;
  switch (activeProfile) {
    case 'professional_profile':
      profilePic = ProfessionalData?.user_profile_url ? ProfessionalData?.user_profile_url : DefaultProfilePic;
      break;
    case 'personal_profile':
      profilePic = Personaldata?.user_profile_url ? Personaldata?.user_profile_url : DefaultProfilePic;
      break;
    case 'finance':
      profilePic = userDetails?.proFile ? userDetails?.proFile : DefaultProfilePic;
      break;
    default:
      profilePic = '';
  }

  // API Calls
  const apiKey = process.env.REACT_APP_API_KEY
  const objectId = localStorage.getItem('objectId');
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
  };
  const dispatch = useDispatch();

  const VisitCardPersonalDetails = useSelector
    ((state) => state?.CardArray?.visitingCard?.personalCardData?.cardDetails);

  const VisitCardPersonalContacts = useSelector
    ((state) => state?.CardArray?.visitingCard?.personalCardData?.contactDetails);

  const VisitCardpersonalQrstyles = useSelector
    ((state) => state?.CardArray?.visitingCard?.personalCardData?.qrStyles);

  const VisitCardProfessionalDetails = useSelector
    ((state) => state?.CardArray?.visitingCard?.professionalCardData?.cardDetails);

  const VisitCardProfessionalContacts = useSelector
    ((state) => state?.CardArray?.visitingCard?.professionalCardData?.contactDetails);

  const VisitCardProfessionalQrstyles = useSelector
    ((state) => state?.CardArray?.visitingCard?.professionalCardData?.qrStyles);

  const VisitCardToken = useSelector
    ((state) => state?.CardArray?.visitingCard?.accessToken)
  const exploreType = useSelector((state) => state?.community?.exploreType);
  const [personalCardDetails, setPersonalCardDetails] = useState({
    cardName: 'Personal',
    userRefId: viewedUserId,
    encryptedId: encryptedId,
    firstName: '',
    lastName: '',
    token: '',
    title: '',
    profile_pic: '',
    logo: '',
    defaultPhone: '',
    defaultEmail: ''
  })

  const [professionalCardDetails, setProfessionalCardDetails] = useState({
    cardName: 'Professional',
    userRefId: viewedUserId,
    encryptedId: encryptedId,
    designation: '',
    firstName: '',
    lastName: '',
    token: '',
    company: '',
    profile_pic: '',
    logo: '',
    defaultPhone: '',
    defaultEmail: ''
  })

  const [personalCardContacts, setPersonalCardContacts] = useState({
    cardName: 'Personal',
    mobile_number: phoneNumber,
    call_visible: true,
    sms_visible: true,
    email: emailId,
    email_visible: true,
    whatsapp: phoneNumber,
    whatsapp_visible: true
  });

  const [professionalCardContacts, setProfessionalCardContacts] = useState({
    cardName: 'Professional',
    mobile_number: phoneNumber,
    call_visible: true,
    sms_visible: true,
    email: emailId,
    email_visible: true,
    whatsapp: phoneNumber,
    whatsapp_visible: true
  });

  const [personalSocials, setPersonalSocials] = useState({
    cardName: 'Personal',
    links: []
  })

  const [professionalSocials, setProfessionalSocials] = useState({
    cardName: 'Professional',
    links: []
  })

  const [personalQrStyles, setPersonalQrStyles] = useState({
    CardName: 'Personal',
    eyeBall: '',
    eyeBallcolor: '',
    eyeFrame: '',
    eyeFrameColor: '',
    qrPattern: '',
    qrPatterncolor: '#121212',
    border: '',
    bordercolor: '',
    addbg: '',
    addbgcolor: '#ede8e8'
  });

  const [professionalQrStyles, setProfessionalQrStyles] = useState({
    CardName: 'Professional',
    eyeBall: '',
    eyeBallcolor: '',
    eyeFrame: '',
    eyeFrameColor: '',
    qrPattern: '',
    qrPatterncolor: '#121212',
    border: '',
    bordercolor: '',
    addbg: '',
    addbgcolor: '#ede8e8',
    logo: ''
  });

  const [isOwnerAndViewer, setIsOwnerAndViewer] = useState(false);

  useEffect(() => {
    if (ProfessionalData?.user_ref_id) {
      setIsOwnerAndViewer(ProfessionalData?.user_ref_id === viewedUserId);
    }
  }, [ProfessionalData, viewedUserId]);


  // const MyComponent = () => {

  const getCardDetails = useCallback(async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/getacardadditionalinfo`, {
        cardTypes: ['Personal', 'Professional'],
        viewedUserId: viewedUserId,
      }, { headers });

      const personalDetails = response.data?.Personal[0] || {};
      const professionalDetails = response.data?.Professional[0] || {};

      setPersonalCardDetails({
        cardName: personalDetails.CardName,
        title: personalDetails.title || '',
        profile_pic: personalDetails.profile_pic || '',
        userRefId: viewedUserId,
        encryptedId: encryptedId,
      });

      if (Object.keys(professionalDetails).length > 0) {
        setProfessionalCardDetails({
          cardName: professionalDetails.CardName,
          designation: professionalDetails.designation || '',
          company: professionalDetails.company || '',
          profile_pic: professionalDetails.profile_pic || '',
          logo: professionalDetails.logo || '',
          userRefId: viewedUserId,
          encryptedId: encryptedId,
        });
      } else {
        setProfessionalCardDetails({});
      }
    } catch (error) {
      console.error('Error sending card details:', error);
    }
  }, [viewedUserId, encryptedId]);

  const getUserDetails = useCallback(async () => {
    try {

      // console.log('Inside the sideFeed - viewedUserId:', viewedUserId); // Verify viewedUserId inside the function
      // console.log('Payload for API call:', { referenceId: viewedUserId });
      const response = await callApiFunction('userDetailedView', {
        referenceId: viewedUserId,

      });
      console.log("UserDetails inside the Sidefeed", response);
      if (response?.status === "SUCCESS") {
        const responseData = response?.data;
        const cardNames = responseData?.card_names || [];


        const personalCard = cardNames.find(card => card.card_type === 'Personal');
        const professionalCard = cardNames.find(card => card.card_type === 'Professional');

        if (personalCard) {
          setPersonalCardDetails((prevData) => ({
            ...prevData,
            cardName: 'Personal',
            firstName: responseData?.first_name || responseData?.name,
            lastName: responseData?.last_name,
            token: response?.token,
            defaultEmail: responseData?.email,
            defaultPhone: responseData?.phone_no.replace(/\s+/g, ""),
          }));
        }

        if (professionalCard) {
          setProfessionalCardDetails((prevData) => ({
            ...prevData,
            cardName: 'Professional',
            firstName: responseData?.first_name || responseData?.name,
            lastName: responseData?.last_name,
            token: response?.token,
          }));
        }
      }
    } catch (error) {
      console.log('Error:', error);
    }
  }, [viewedUserId, encryptedId]);

  // const getCardContacts = useCallback(async () => {
  //   try {
  //     const personalResponse = await axios.get('/card/getcard-contacts', {
  //       params: { card_type: 'Personal', viewedUserId: encryptedId },
  //       headers: headers,
  //     });
  //     setPersonalCardContacts(personalResponse?.data[0] || {});
  //     console.log("contact detailss inside the sidefeed", personalResponse);
  //     const professionalResponse = await axios.get('/card/getcard-contacts', {
  //       params: { card_type: 'Professional', viewedUserId: encryptedId },
  //       headers: headers,
  //     });
  //     setProfessionalCardContacts(professionalResponse?.data[0] || {});
  //   } catch (error) {
  //     console.error('Error fetching card contact details:', error);
  //   }
  // }, [encryptedId]);

  const getSocials = useCallback(async () => {
    try {
      const personalResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`, {
        params: { cardType: 'Personal', viewedUserId: encryptedId },
        headers: headers,
      });

      const personalTransformedLinks = personalResponse?.data.map((link) => ({
        network: link.info_key,
        url: link.info_value,
        visible: link.is_visible,
      }));

      const personalUniqueLinks = personalTransformedLinks.filter((link, index, self) =>
        index === self.findIndex((t) => t.network === link.network)
      );

      setPersonalSocials({ links: personalUniqueLinks });

      const professionalResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`, {
        params: { cardType: 'Professional', viewedUserId: encryptedId },
        headers: headers,
      });

      const professionalTransformedLinks = professionalResponse?.data.map((link) => ({
        network: link.info_key,
        url: link.info_value,
        visible: link.is_visible,
      }));

      const professionalUniqueLinks = professionalTransformedLinks.filter((link, index, self) =>
        index === self.findIndex((t) => t.network === link.network)
      );
      setProfessionalSocials({ links: professionalUniqueLinks });

    } catch (error) {
      console.error('Error fetching Social Links in Profile:', error);
    }
  }, [encryptedId]);

  const hasFetchedData = useRef(false);

  useEffect(() => {
    if (!encryptedId || !viewedUserId || hasFetchedData.current) return;

    const fetchData = async () => {
      // await visitAPI();
      await getSocials();
      hasFetchedData.current = true; //  Correctly updating the ref
    };

    fetchData();
  }, [encryptedId, viewedUserId]); //  Re-run when encryptedId changes


  useEffect(() => {
    // if (!encryptedId || !viewedUserId || hasFetchedData.current) return;
    const Visitingfuncationcall = async () => {
      await visitAPI();
    }
    Visitingfuncationcall();
  }, [activeProfile])

  useEffect(() => {
    GetAllEvents()
  }, [activeProfile]);

  async function GetAllEvents(){
    // compute the type locally so we don't rely on the store update timing
    const typeParam = activeProfile === 'professional_profile' ? 'PROFESSIONAL' : 'PERSONAL';

    // update store so other components still see the chosen type
    await dispatch(setExploreType(typeParam));

    // use the local typeParam when requesting events / attendees to avoid stale exploreType
    await dispatch(getAllEvents({ page: 0, type: typeParam }));
    await dispatch(getRegisteredAttendees({ type: typeParam }));

    console.log(`IAM FROM ${typeParam} PROFILE SIDEFEED`);
    setEvent(typeParam);
  }

  const visitAPI = async () => {
    const response = await dispatch(getVisitingCardReducer({ encryptedId }));
    if (response?.payload?.statusCode === 200) {
      const data = response?.payload?.data;
      setPersonalCardDetails((prestate) => ({
        ...prestate,
        cardName: data?.personalCardData?.cardDetails?.CardName,
        token: response?.payload?.data?.accessToken,
        firstName: data?.personalCardData?.
          cardDetails?.first_name,
        lastName: data?.personalCardData?.cardDetails?.last_name,
        profile_pic: data?.personalCardData?.cardDetails?.profile_pic,
        title: data?.personalCardData?.cardDetails?.title,
        defaultPhone: data?.personalCardData?.cardDetails?.phone_no,
        defaultEmail: data?.personalCardData?.cardDetails?.email
      }));
      setProfessionalCardDetails((prestate) => ({
        ...prestate,
        cardName: data?.professionalCardData?.cardDetails?.CardName,
        token: VisitCardToken,
        firstName: data?.professionalCardData?.cardDetails?.first_name,
        lastName: data?.professionalCardData?.cardDetails?.last_name,
        profile_pic: data?.professionalCardData?.cardDetails?.profile_pic,
        designation: data?.professionalCardData?.cardDetails?.designation,
        logo: data?.professionalCardData?.cardDetails?.logo,
        defaultPhone: data?.personalCardData?.cardDetails?.phone_no,
        defaultEmail: data?.personalCardData?.cardDetails?.email
      }));

      setPersonalCardContacts(data?.personalCardData?.contactDetails);
      setProfessionalCardContacts(data?.professionalCardData?.contactDetails);

      setPersonalQrStyles(data?.personalCardData?.qrStyles);
      setProfessionalQrStyles(data?.professionalCardData?.qrStyles);
    }

  }
  // }, [encryptedId])

  // console.log("Encrypted ID", encryptedId);
  // console.log("visitingCard Personal data", VisitCardPersonalDetails);
  // console.log("visitingCard personal contact", VisitCardPersonalContacts);
  // console.log("visitingCard Professiona data", VisitCardProfessionalDetails);
  // console.log("visitingCard professional contact", VisitCardProfessionalContacts);
  // console.log("visitingCard professional card style", VisitCardProfessionalQrstyles);


  const cardDetails = activeProfile === 'professional_profile' ? professionalCardDetails : personalCardDetails;
  const cardContacts = activeProfile === 'professional_profile' ? professionalCardContacts : personalCardContacts;
  const cardSocials = activeProfile === 'professional_profile' ? professionalSocials.links : personalSocials.links;
  const cardQrStyles = activeProfile === 'professional_profile' ? professionalQrStyles : personalQrStyles;

  return (
    <div style={{ width: "100%" }}>

      <VisitingCard cardDetails={cardDetails} cardQrstyles={cardQrStyles} cardContacts={cardContacts} activeProfile={activeProfile} isOwner={isOwnerAndViewer} />

      {/* {activeProfile === 'professional_profile' ? <RecommendedJobs /> : <JobOpenings />} */}
      {activeProfile == 'professional_profile' ? <RecommendedJobs /> : ""}

      {/* <UpcomingEvents /> */}

      <div style={{ margin: "10px 0px 10px 0px", height: "auto", overflowY: "hidden", borderRadius: "8px", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>
        {/* <CommunityRightSideBar /> */}
        <UpcomingEventsSidebar />
      </div>

      <SocialNetwork activeProfile={activeProfile} socialLinks={cardSocials} />

      {/* <Offers /> */}

      {/* <RecommendedCourses /> */}


      <Box className='my-2'>
        {/* <div className='w-100'>
          <img className='w-100' src={sampleAd} alt='Ad 1' />
        </div> */}
      </Box>

    </div>
  )
}

export default SideFeedParent

SideFeedParent.defaultProps = {
  activeProfile: 'personal_profile',
}
